import React, { FC } from 'react';
import styles from './search_facets_lib.module.scss';

export const SearchFacetTitle: FC<React.HTMLProps<HTMLDivElement>> = (
  props,
) => {
  return <div className={styles.title} {...props} />;
};
